import { render } from "./Help.vue?vue&type=template&id=4635ea61&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"

import "./Help.vue?vue&type=style&index=0&id=4635ea61&scoped=true&lang=css"

import exportComponent from "/home/syhpoon/UNIX/wealthpic/js/wealthpic-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4635ea61"]])

export default __exports__